'use client';

import { motion, useSpring } from 'motion/react';
import { PropsWithChildren, useRef } from 'react';

interface tilt {
  rotateX: number;
  rotateY: number;
}

interface Props extends PropsWithChildren {
  // ref: RefObject<InteractiveCardHelper.CardContentRef>;
  onMove?: (rotation: tilt) => void;
  maxTilt?: number;
}

const MotionTiltCard: React.FC<Props> = ({
  maxTilt = 15,
  onMove,
  children,
}) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const z = useSpring(0);
  const rotateX = useSpring(0);
  const rotateY = useSpring(0);

  const calculateTilt = (event: React.PointerEvent<HTMLDivElement>): tilt => {
    if (!cardRef.current) return { rotateX: 0, rotateY: 0 };

    const rect = cardRef.current.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    // Convert coordinates to percentages
    const xPercent = x / rect.width;
    const yPercent = y / rect.height;

    return {
      rotateX: maxTilt * (0.5 - yPercent),
      rotateY: maxTilt * (xPercent - 0.5),
    };
  };

  // const onMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
  //   // var { x, y, width, height } = (
  //   //   e.target as HTMLDivElement
  //   // ).getBoundingClientRect();
  //   // const xOffset = e.clientX - x;
  //   // const yOffset = e.clientY - y;
  //   // const normalised = [(width - xOffset) / width, (height - yOffset) / height];
  //   // const values = [0.5 - normalised[0], 0.5 - normalised[1]];
  //   // setSkew([values[0], values[1]]);
  //   // contentRef.current?.onMove(values[0], values[1]);
  // };

  return (
    <motion.div
      ref={cardRef}
      style={{
        ...styles.card,
        z,
        rotateX,
        rotateY,
      }}
      transition={{ type: 'spring', stiffness: 200, damping: 0 }}
      onPointerMove={e => {
        const tilt = calculateTilt(e);
        rotateX.set(tilt.rotateX);
        rotateY.set(tilt.rotateY);
        onMove && onMove(tilt);
      }}
      onPointerLeave={() => {
        rotateX.set(0);
        rotateY.set(0);
        onMove && onMove({ rotateX: 0, rotateY: 0 });
        z.set(0);
      }}
      onPointerEnter={() => {
        z.set(-10);
      }}>
      {children}
    </motion.div>
  );
};
export default MotionTiltCard;

/**
 * ==============   Styles   ================
 */

const styles = {
  card: {
    position: 'relative',
    width: 340,
    height: 400,
    borderRadius: 16,
    // overflow: 'hidden',
    background: 'var(--background)',
    border: '1px solid var(--border)',
    willChange: 'transform',
    transformPerspective: 500,
  },
} as const;
